// components/AlertModal.js
import React from 'react';
import './ConfirmModal.css'; // optional styling

const AlertModal = ({ message, onClose }) => {
  return (
    <div className="alert-modal-backdrop">
      <div className="alert-modal-box">
        <p>{message}</p>
        <div className="alert-modal-buttons">
          <button className="button blue" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
